var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { LiveOutrightDetails } from "../LiveOutrightDetails";
import { MarketsCountLink } from "../MarketsCountLink";
import { MarketsWrapLiveOutright } from "../MarketsWrapLiveOutright";
let LiveOutright = class LiveOutright extends React.Component {
    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this */
    constructor(props) {
        super(props);
        this.componentPrefix = "live-outright";
    }
    render() {
        return (React.createElement("div", { className: `rj-ev-list__${this.componentPrefix}`, "data-uat": `div-ev-list-${this.componentPrefix}` },
            React.createElement("div", { className: `rj-ev-list__${this.componentPrefix}__inner`, "data-uat": `div-ev-list-${this.componentPrefix}-inner` },
                React.createElement(LiveOutrightDetails, { details: this.props, componentPrefix: this.componentPrefix }),
                React.createElement(MarketsWrapLiveOutright, { details: this.props, componentPrefix: this.componentPrefix }),
                React.createElement(MarketsCountLink, { details: this.props, componentPrefix: this.componentPrefix }))));
    }
};
LiveOutright = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], LiveOutright);
export { LiveOutright };
//# sourceMappingURL=LiveOutright.js.map